<template>
  <div class="w-full py-6 box-border relative">
    <header class="pl-5 pr-4 border-l-4 border-solid border-theme text-medium-x text-theme-black-850 font-semibold">
      样本服务是什么？
    </header>
    <p class="mt-2 pl-6 pr-4 box-border text-theme-black-850 text-medium leading-24">
      样本服务是<span v-custom="'out_D74'">调研工厂</span>提供的样本付费服务，百万真实精确人群供您选择推送，助你快速高质回收答卷。
      <span class="text-theme select-none cursor-pointer" @click="toMore">了解更多</span>
    </p>
    <div class="absolute bottom-0 w-full h-px px-6 box-border" v-if="border">
      <div class="w-full f-full border-b border-solid border-border-gray" />
    </div>
  </div>
</template>

<script>
import { propMixins } from '@/mixins/publish';
import { toSurveyBase } from '@/assets/js/base-platform.js'

export default {
  name: 'SampleServiceWhat',
  mixins: [propMixins],
  props: {
    border: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    toMore() {
      toSurveyBase('/sampleser')
    }
  }
}
</script>